import "@postenbring/hedwig-css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "../css/main.css";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router";
import ErrorPage from "./ErrorPage/ErrorPage";
import {
  entrypointLoader,
  entrypointMiddleware,
  ROOT_ROUTE_ID,
} from "./infrastructure/entrypoint/EntrypointContext";
import { LanguageProvider } from "./infrastructure/translation/LanguageContext";
import ScreenSizeContextProvider from "./infrastructure/screenSize/ScreenSizeContext";
import { LoadingPage } from "./LoadingPage/LoadingPage";
import appRoutes from "./infrastructure/routing/AppRoutes";

const router = createBrowserRouter([
  {
    path: "/:language?",
    id: ROOT_ROUTE_ID,
    element: <App />,
    errorElement: <ErrorPage />,
    middleware: [entrypointMiddleware],
    loader: entrypointLoader,
    children: appRoutes,
    hydrateFallbackElement: <LoadingPage />,
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LanguageProvider>
      <ScreenSizeContextProvider>
        <RouterProvider router={router} />
      </ScreenSizeContextProvider>
    </LanguageProvider>
  </StrictMode>,
);
